export class Invoice {
    constructor() {
        this.setInvoiceEmail = document.querySelector('#setInvoiceEmail');
        this.checkInvoiceEmail = document.querySelector('#invoice-email');
        this.checkInvoiceIban = document.querySelector('#invoice-iban');
        this.invoiceVkorg = document.querySelector('#invoiceVkorg');
        this.accountnumber = document.querySelector('#payment-accountnumber');
        this.bankcode = document.querySelector('#payment-bankcode');
        this.ibancalculator = document.querySelector('#ibancalculator');
        this.iban = document.querySelector('#payment-iban');
        this.error = document.querySelector('.text-danger');
        this.sepa = document.querySelector('#sepa');
        this.initService();
    };

    initService() {
        if(!this.checkInvoiceEmail) {
            this.checkInvoiceEmail = { checked : false };
        }
        if(this.setInvoiceEmail) {
            this.setInvoiceEmail.addEventListener('click', event => {
                event.preventDefault();
                if(this.checkInvoiceIban.checked || this.checkInvoiceEmail.checked) {
                    let request = new Request('POST', document.location.pathname);
                    
                    request.data = {
                        iban: (this.checkInvoiceIban.checked) ? this.iban.value : 0,
                        email: (this.checkInvoiceEmail.checked) ? 1 : 0,
                    };

                    request.call(response => {
                        if(response.status == 'ok') {
                            window.location = document.location.pathname + '/success';
                        } else {
                            this.error.innerHTML = response.msg;
                        }
                    });
                }
            });
        }

        if(this.checkInvoiceIban) {
            this.checkInvoiceIban.addEventListener('click', event => {
                if(this.checkInvoiceIban.checked) {
                    this.sepa.classList.remove('d-none');
                } else {
                    this.sepa.classList.add('d-none');
                }
            });
        }

        let ibanCalculator = document.querySelector('.iban-calculator');
        
        if(ibanCalculator) {
            ibanCalculator.addEventListener('click', event => {
                this.ibancalculator.classList.toggle('d-none');
            });
        }

        this.accountnumber.addEventListener('blur', event => {
            this.generateIban();
        });

        this.bankcode.addEventListener('blur', event => {
            this.generateIban();
        });
    };

    generateIban() {
        if(this.accountnumber.value != "" && this.bankcode.value != "") {
            this.iban.setAttribute('placeholder', 'errechne IBAN...');
            this.iban.value = '';
            
            let request = new Request('POST', '/service-payment/generate-iban');
            request.data = {
                'Payment[accountnumber]': this.accountnumber.value,
                'Payment[bankcode]': this.bankcode.value,
            };

            request.call(response => {
                if(response.iban) {
                    this.iban.value = response.iban;
                    this.iban.setAttribute('placeholder', 'IBAN');
                    this.ibancalculator.classList.toggle('d-none');
                    this.accountnumber.value = '';
                    this.bankcode.value = '';
                }
            });
        }
    };
};
